module.exports = __webpack_public_path__ + "img/Lisa-EINS.70d30b0e.jpg";